// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { IStackStyles, Stack } from '@fluentui/react';
import { SignInOutButton } from '../components/SignInOutButton';
import { HomeButton } from 'components/HomeButton';
import { FeedbackButton } from 'components/Feedback/FeedbackButton';
import { ThemeToggleButton } from 'components/ThemeToggleButton';
import { ExperimentsButton } from 'experiments/ExperimentsButton';
import { useIsSignedIn } from 'hooks/useUser';

export const Header = (props: { callId: string | undefined; onHomeClick: () => void }): JSX.Element => {
  const isSignedIn = useIsSignedIn();
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalFill
      verticalAlign="center"
      styles={headerContainerStyles}
    >
      <Stack.Item>
        <HomeButton onClick={props.onHomeClick} />
      </Stack.Item>
      <Stack.Item>
        <Stack horizontal verticalFill verticalAlign="center" tokens={{ childrenGap: '1rem' }}>
          <Stack.Item>
            <ThemeToggleButton />
          </Stack.Item>
          {isSignedIn && (
            <Stack.Item>
              <Stack horizontal tokens={{ childrenGap: '0.5rem' }}>
                <ExperimentsButton />
                <FeedbackButton callId={props.callId} />
              </Stack>
            </Stack.Item>
          )}
          <Stack.Item>
            <SignInOutButton resetToHome={props.onHomeClick} />
          </Stack.Item>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};

const headerContainerStyles: IStackStyles = {
  root: {
    padding: '1rem',
    height: '3rem'
  }
};
